import SimpleStore from './simple-store';
import Menu from './menu';
import CompanyLoader from './company-loader';
import './links';

const $ = window.jQuery;

class Winkelpark {
  /**
   * Sets necessary variables for this class
   * that are used throughout
   */
  constructor() {
    this.name = 'Winkelpark Theme';
    this.menu = new Menu();
    this.companyLoader = new CompanyLoader();
    this.simpleStore = new SimpleStore('.product .product-amount');

    this.loadingOverlay = $('.loading-overlay');
  }

  /**
   * Initializes all needed functions
   */
  init() {
    $('html').attr('class', 'js');

    this.removeLoadingOverlay();
    Winkelpark.addScrollEventListener();

    Winkelpark.checkFooterForMobile();
    this.companyLoader.init();
    this.simpleStore.init();
    Winkelpark.initMap();

    $('.gallery-thumbnail').on('click', event => Winkelpark.showGalleryImage(event));
  }

  removeLoadingOverlay() {
    this.loadingOverlay[0].addEventListener('transitionend', () => {
      this.loadingOverlay.hide();
    });
  }

  static addScrollEventListener() {
    $(window).on('scroll', () => {
      const body = $('body');

      if ($(window).scrollTop() >= 50) {
        body.addClass('is-sticky');
      } else {
        body.removeClass('is-sticky');
      }
    });
  }

  static checkFooterForMobile() {
    const rowsInMain = $('.main .container .vc_row');

    if (rowsInMain.length && $(rowsInMain[rowsInMain.length - 1]).css('margin-bottom') === '-35px') {
      $('.main').css('margin-bottom', '35px');
    }
  }

  static initMap() {
    if (typeof (locations) === 'undefined' || !locations.length) {
      return;
    }

    const mapEl = $('.google-map');

    if (!mapEl.length) {
      return;
    }

    const map = new google.maps.Map(mapEl[0], {
      zoom: 16,
      streetViewControl: false,
      mapTypeControl: false,
      mapTypeId: 'terrain',
      styles: [
        {
          featureType: 'poi',
          stylers: [{ visibility: 'off' }],
        },
      ],
      center: {
        lat: Number(locations[0].lat),
        lng: Number(locations[0].lng),
      },
    });

    map.markers = [];

    locations.forEach((location) => {
      if (location.marker === false) {
        return;
      }

      let infoWindow = false;
      if (location.content) {
        infoWindow = new google.maps.InfoWindow({
          content: location.content,
        });
      }

      const marker = new google.maps.Marker({
        infoWindow,
        map,
        position: {
          lat: Number(location.lat),
          lng: Number(location.lng),
        },
        label: {
          text: location.label,
          fontSize: '16px',
          fontWeight: 'bold',
          color: 'red',
        },
        icon: {
          url: '/wp-content/themes/winkelpark/dist/static/maps/marker.svg',
          labelOrigin: new google.maps.Point(10, 45),
        },
      });

      marker.addListener('click', () => {
        infoWindow.open(this.map, marker);
      });

      map.markers.push(marker);
    });

    // this.MarkerClusterer = new MarkerClusterer(map, map.markers, {
    //   maxZoom: 18,
    //   styles: [{
    //     textColor: 'white',
    //     className: 'map-markers',
    //     width: 53,
    //     height: 53,
    //     url: '/wp-content/themes/winkelpark/dist/static/maps/M1.png',
    //   }],
    // });
  }

  static showGalleryImage(event) {
    const thumbnail = $(event.currentTarget);
    const largeSrc = thumbnail.data('image-large');
    const featuredImg = $('.featured-image img', thumbnail.parents('.gallery'));

    // Reset all active thumbnails
    $('.gallery-thumbnail', thumbnail.parents('.gallery')).removeClass('active');

    // Set thumbnail to active
    thumbnail.addClass('active');

    // Switch the source of the featured image
    featuredImg.attr('src', largeSrc);
  }
}

$(document).ready(() => {
  const jc = new Winkelpark();
  jc.init();
});
